<router-outlet (activate)="onActivate()"></router-outlet>

@if (!routeLoaded) {
  <div class="sync-page-container preloader">
    <app-placeholder placeholder="home-panel"></app-placeholder>
  </div>
} @else {
  <app-footer></app-footer>
}
